import React, { createContext, useContext, useMemo } from 'react';

// Site configuration mapping
const SITE_CONFIG = {
  // KSA Sites
  'ksa.dev.local': { country: 'KSA', countryCode: 'SA', currency: 'SAR' },
  'bmcuat.bmc.edu.sa': { country: 'KSA', countryCode: 'SA', currency: 'SAR' },
  'bmc.edu.sa': { country: 'KSA', countryCode: 'SA', currency: 'SAR' },
  'application-form.dev.local': { country: 'KSA', countryCode: 'SA', currency: 'SAR' },
  'localhost': { country: 'KSA', countryCode: 'SA', currency: 'SAR' },
  
  // UAE Sites
  'uae.dev.local': { country: 'UAE', countryCode: 'AE', currency: 'AED' },
  'bmcuat.bmc.ac.ae': { country: 'UAE', countryCode: 'AE', currency: 'AED' },
  'bmc.ac.ae': { country: 'UAE', countryCode: 'AE', currency: 'AED' },
};

const DEFAULT_SITE = { country: 'KSA', countryCode: 'SA', currency: 'SAR' };

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const siteConfig = useMemo(() => {
    // Get hostname from window (client-side only)
    let hostname = '';
    if (typeof window !== 'undefined') {
      hostname = window.location.hostname;
    }
    
    // Check hostname mapping
    const config = SITE_CONFIG[hostname] || DEFAULT_SITE;
    
    return {
      ...config,
      hostname,
      isKSA: config.country === 'KSA',
      isUAE: config.country === 'UAE',
    };
  }, []);

  return (
    <SiteContext.Provider value={siteConfig}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    // Return default if used outside provider (SSR safety)
    return { ...DEFAULT_SITE, isKSA: true, isUAE: false, hostname: '' };
  }
  return context;
};

export default SiteContext;
